import React, {useState,useEffect}  from "react";
import { useDispatch,useSelector,shallowEqual  } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import AppHeader from "../Header/AppHeader";
import LeftMenu from '../LeftMenu'
import {useStyles} from "./styles";
import {PermissionContext,extractPrivileges} from "../PermissionContext";
import Announcement from "../../components/Header/Announcement";
import MFAConfig from "@components/UserProfile/MFAConfig";

import Grid from '@mui/material/Grid';
const stateSelector = state => ({
  selectedClinicId: state.clinicReducer.selectedClinicId,
  userRole: state.userReducer.userRole,
  userPreferences: state.userReducer.userPreferences,
  mfaSetupPending:state.userReducer.mfaSetupPending,
  userPermissionsBasedOnClinic: state.userReducer.userPermissionsBasedOnClinic,
});

const LeftMenuAndFooter = (props) => {
  const { selectedClinicId, userRole, userPermissionsBasedOnClinic,userPreferences,mfaSetupPending } = useSelector(state => stateSelector(state),shallowEqual);
  const {privileges,permissionsLoaded,isAdmin,hasAccess} = extractPrivileges(userPermissionsBasedOnClinic,userRole,selectedClinicId);
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(true);
  const [open, setOpen] = useState(false);
  const [refresh,setRefresh] = useState(true);

  const handleIconClick = () => {
    setIsOpen(!isOpen);
  }

  const handleClick = (e,flag) => {
    setOpen(pv=>flag==undefined?!pv:flag);
  };

  const onRefresh = () => {
    setRefresh(!refresh);
  };

  let wrapperClassName = `page-content-ctr ${classes.AdminWraper} ${!isOpen?classes.activeClass:''} ${props.containerClass || ''} footer-${!!props.footer}`;
  const childrenWithProps = React.Children.map(props.children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { isLeftMenuOpen: open,clinicId:selectedClinicId,footer:!!props.footer});
    }
    return child;
  });
  return (
    <>
    <PermissionContext.Provider value={{privileges,isAdmin,hasAccess}}>
      <AppHeader
        handleIconClick={handleIconClick}
        isTopMenuFullWidth={isOpen}
        checkPermission={permissionsLoaded}
        headerOpts={{...props?.headerOpts}}
      />
      <Announcement />
      <Grid className={wrapperClassName}>
        {props.showLeftMenu && <LeftMenu
          handleClick={handleClick}
          onRefresh={onRefresh}
          open={open}
          isLeftFullwidth={!isOpen}
        />}
        <div className={`page-data ${classes.AdminUser} ${props.contentClass||''} footer-${!!props.footer}`}>
          <div key={selectedClinicId} className={`${classes.dashboardsMainParent} page-data-child`}>
            {(userPreferences.clinicSelectionPending || userPreferences.clinicSwitching || !selectedClinicId || !permissionsLoaded || mfaSetupPending)?<div className="loader-inline"><CircularProgress/>{mfaSetupPending && <MFAConfig mfaRequired popup/>}</div>:childrenWithProps}
          </div>
      </div>
    </Grid>   
    </PermissionContext.Provider>
    </>
  );
}

export default LeftMenuAndFooter
